import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import { connect } from 'react-redux';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { AbsolutePane, Button, FlexPane, Image, Text, DocumentHead, DefaultHeadMetaFactory } =
    MojitoPresentation.Components;
const intentActions = MojitoCore.Intents.actions;
const IntentActionTrigger = MojitoPresentation.Base.Intent.IntentActionTrigger;

class BadRoutePageView extends UIViewImplementation {
    constructor(props) {
        super(props);

        // Creating the MetaFactory instance here to avoid re-creating it on every render()
        const metaFactory = this.config.documentHeadMetaFactory || DefaultHeadMetaFactory;
        this.documentHeadMetaFactory = new metaFactory(this.l10n);
        this.onInfoLinkClick = this.onInfoLinkClick.bind(this);
    }

    onInfoLinkClick() {
        const { dispatch } = this.props;
        const intent = this.config.infoLinkIntent;

        if (intent && intent.type) {
            dispatch(intentActions.publishIntent(intent.type, intent.data));
        } else {
            IntentActionTrigger.showHomePage();
        }
    }

    renderBadRouteContent() {
        return (
            <FlexPane config={this.config.infoContainer}>
                <Text config={this.config.errorCode}>
                    {this.l10n.BAD_ROUTE_PAGE_VIEW.ERROR_CODE}
                </Text>
                <Text config={this.config.information}>
                    {this.l10n.BAD_ROUTE_PAGE_VIEW.INFORMATION}
                </Text>
                <Button
                    class="ta-Button-Home"
                    config={this.config.homeButton}
                    onClick={this.onInfoLinkClick}
                >
                    {this.l10n.BAD_ROUTE_PAGE_VIEW.BUTTON_TEXT}
                </Button>
                <Image class="ta-Image-Logo" config={this.config.logo} />
            </FlexPane>
        );
    }

    renderDocumentHead() {
        const headData = {
            title: '$BAD_ROUTE_PAGE_VIEW.PAGE_TITLE',
            keywords: '$BAD_ROUTE_PAGE_VIEW.PAGE_KEYWORDS',
            description: '$BAD_ROUTE_PAGE_VIEW.PAGE_DESCRIPTION',
            canonical: '$BAD_ROUTE_PAGE_VIEW.PAGE_CANONICAL',
        };

        return (
            <DocumentHead
                config={this.config.documentHeadBadRoutes}
                data={headData}
                metaFactory={this.documentHeadMetaFactory}
            />
        );
    }

    render() {
        return (
            <>
                {this.renderDocumentHead()}
                <AbsolutePane config={this.config.container}>
                    {this.renderBadRouteContent()}
                </AbsolutePane>
            </>
        );
    }
}

export default connect()(BadRoutePageView);
